var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuildingEnquiry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.411,
    height: 34.191,
    viewBox: "0 0 30.411 34.191",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9111"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(12.901 6.466)",
    style: {
      strokeWidth: "1.8px",
      strokeLinecap: "round",
      fill: "none",
      stroke: "currentColor",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M0 0v10.244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.728 134.725a2.94 2.94 0 0 1-2.947 2.891c-.792 0-2.832.013-2.832.013s-.013-2.1-.013-2.9c0-.661-.007-2.891-.007-2.891h2.852a2.939 2.939 0 0 1 2.947 2.887z",
    transform: "translate(-213.027 -125.368)",
    style: {
      strokeWidth: "1.8px",
      strokeLinecap: "round",
      fill: "none",
      stroke: "currentColor",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.6 413.094c5.167.229 9.138 1.608 9.138 3.275 0 1.827-4.774 3.309-10.663 3.309s-10.663-1.482-10.663-3.309c0-1.667 3.972-3.046 9.139-3.275",
    transform: "translate(-106.865 -388.978)",
    style: {
      strokeWidth: "1.5px",
      fill: "none",
      stroke: "currentColor",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.616 21.663a10.663 10.663 0 1 0-14.23 10.05l3.567 5.945 3.567-5.945a10.666 10.666 0 0 0 7.096-10.05z",
    transform: "translate(-77.747 -10.25)",
    style: {
      strokeWidth: "1.5px",
      strokeLinecap: "round",
      fill: "none",
      stroke: "currentColor",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "XMLID_571_",
    d: "M127.93 413.094c7 .325 12.389 2.278 12.389 4.639 0 2.588-6.472 4.687-14.455 4.687s-14.455-2.1-14.455-4.687c0-2.361 5.384-4.314 12.389-4.639",
    transform: "translate(-110.658 -388.979)",
    style: {
      strokeWidth: "1.5px",
      fill: "none",
      stroke: "currentColor",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingEnquiry);
export default __webpack_public_path__ + "static/media/building_enquiry.64b01b8cf43b0c00b0fc0802209488a5.svg";
export { ForwardRef as ReactComponent };